/**
 * CurrentVoyage. Keeps the state of the current voyage.
 *
 * Start, end, refresh, get/set current voyage.
 *
 * Also retrives fuel/LNG tank info.
 * TODO: Move everything with fuel tank info
 *
 */

var VRC = VRC || {};
VRC.CurrentVoyage = (function () {
	var currentVoyage;
	var _fuelTankInfo = {};

	var init = function () {
		if (!currentVoyage) {
			currentVoyage = VRC.Voyage();
			currentVoyage.load();
			VRC.VoyageNoView.update(currentVoyage.getSeqNo());
			VRC.MissionTypeService.init();
			setFuelTankInfo();
		}
		VRC.VoyageNoView.update(currentVoyage.getSeqNo());
	};
	var setFuelTankInfo = function () {
		var fuelTanks = VRC.BulkTankManager.getFuelTanks();
		for (var ii = 0; ii < fuelTanks.length; ii++) {
			if (fuelTanks[ii].isFuel()) {
				_fuelTankInfo.hasFuel = true;
			}
			else if (fuelTanks[ii].isLng()) {
				_fuelTankInfo.hasLng = true;
			}
		}
	};

	var getFuelTankInfo = function () {
		return _fuelTankInfo;
	};

	var getCurrentVoyage = function () {
		if (!currentVoyage) {
			init();
		}
		return currentVoyage;
	};

	//Rendering
	var onVoyageLogChange = function () {
		currentVoyage.calcFromDate();
		VRC.CurrentVoyageView.init();


		$('select.log_entry_place:not(.selectized)').selectize(VRC.Utils.Selectize.getConfig());
	};

	var refresh = function () {
		currentVoyage.save();
		g_voyage_planning.SaveLogEntries();
		VRC.MissionTypeService.init();

		g_voyage_planning.LoadLogEntries();
        VRC.VoyageLogTableView.init();

	};

	var hasCurrentVoyage = function () {
		var hasCurrentVoyage = false;

		if (currentVoyage) {
			if (currentVoyage.getVoyageId()) {
				hasCurrentVoyage = true;
			}
		}

		return hasCurrentVoyage;
	};

	var fetchNewVoyage = function () {
		var startingNewVoyage = VRC.CommunicationService.fetchData(null, 'start_new_voyage', {});
		VRC.LoadingModal.show();
		startingNewVoyage.done(function (owner, data) {
			data = data || {};
			VRC.ImportService.importData(data);


			VRC.LoadingModal.hide();
		});
	};

	var endVoyage = function () {
		var json = currentVoyage.toJson();
		var endVoyage = VRC.CommunicationService.fetchData(null, 'end_voyage', json);

		endVoyage.done(function (owner, data) {
			currentVoyage = null;
			VRC.BulkState.importData({});
			g_voyage_planning.ParseLogData({});
			VRC.BulkState.importData({});
			VRC.CurrentVoyage.importData({});

		});

		endVoyage.fail(function (owner, data) {
			console.error('Something went wrong', owner, data)
		});
	};

	var importData = function (data) {
		currentVoyage = VRC.Voyage();
		currentVoyage.parse(data);
		currentVoyage.save();
		VRC.VoyageState.init();
	};

	return {
		init: init,
		refresh: refresh,
		getCurrentVoyage: getCurrentVoyage,
		onVoyageLogChange: onVoyageLogChange,
		getFuelTankInfo: getFuelTankInfo, //consider move
		hasCurrentVoyage: hasCurrentVoyage,
		fetchNewVoyage: fetchNewVoyage,
		importData: importData,
		endVoyage: endVoyage
	}
    
})();
